import module from 'fan/proyecto/module.js'
import colores from './colores.json'
import template from './template.html'

export class FanProyectoEsquemasEsquemaComisionistasComponent {
  ngModel
  total = 0
  data = []
  colores = colores

  $onInit () {
    this.ngModel['$render'] = this.render.bind(this)
    this.ngModel.$validators.percent = (value) => !this.error && value.length
  }

  actualizar () {
    this.data = [...this.data]
    this.totalizar()
    this.ngModel.$setViewValue(this.error ? undefined : [...this.data])
  }

  agregar (item) {
    this.agregando = false

    if (!item) return

    this.data.push({...item, comision_porcentaje: Math.max(0, +(1 - this.total).toFixed(4))})

    this.actualizar()
  }

  eliminar (item) {
    this.data.splice(this.data.indexOf(item), 1)
    this.actualizar()
  }

  render () {
    this.data = this.ngModel.$modelValue || []
    this.totalizar()
  }

  totalizar () {
    this.total = +this.data.reduce((total, item) => total + item.comision_porcentaje, 0).toFixed(4)
    this.error = this.total !== 1
  }
}

module.component('fanProyectoEsquemasEsquemaComisionistas', {
  controller: FanProyectoEsquemasEsquemaComisionistasComponent,
  template,
  require: {
    ngModel: 'ngModel',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/esquema/comisionistas/component.js